import { useRef, useEffect, useState } from 'react';
import {
  deletedDuplicateByAuthor,
  getActiveState,
} from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { v4 as uuidv4 } from 'uuid';
import useLocalStorage from './useLocalStorage';
import { loadAvatarAndAttach, loadImages } from 'helpers/preload';

export const useCarousel = ({
  currentState,
  RND_SLOW,
  RND_FAST,
  RND_WIN,
  RND_CLEAR,
  QUIZ_AVATARS,
}) => {
  const {
    user,
    carousel = '1',
    repeatCount = 50000,
    startFrom,
    speedFast,
    speedSlow,
  } = useGetParams();
  // const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);
  const [showedMessagesF2, setShowedMessagesF2] = useState([]);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const nextMessageF2IndexRef = useRef(-1);

  const messagesRef = useRef([]);
  const messagesRefF2 = useRef([]);

  const currentMessageRef = useRef(null);
  const winnerMessageRef = useRef(null);

  const [winIds, setWinIds] = useLocalStorage('winIds', []);

  // время затраченное на появления одного сообщения в ms
  const [speed, setSpeed] = useState(500);

  const iactiveIdRef = useRef('');

  const protocol = window?.location.protocol || 'https:';

  const prevStateRef = useRef(null);

  useEffect(() => {
    let prevState = prevStateRef.current;

    if (prevState === RND_WIN && [RND_SLOW, RND_FAST].includes(currentState)) {
      setSpeed(speedSlow + 500);
      setTimeout(() => {
        setShowedMessages(
          showedMessages.filter((item) => !winIds.includes(item.id)),
        );
      }, 100);

      setTimeout(() => {
        setSpeed(currentState === RND_SLOW ? speedSlow : speedFast);
      }, speedSlow + 500);
    }

    if (currentState === RND_SLOW && speed !== speedSlow) {
      setSpeed(speedSlow);
    } else if (currentState === RND_FAST && speed !== speedFast) {
      setSpeed(speedFast);
    }

    if (currentState === RND_WIN) {
      if (
        winnerMessageRef.current &&
        !winIds.includes(winnerMessageRef.current.id)
      ) {
        setWinIds([...winIds, winnerMessageRef.current.id]);
        messagesRef.current = messagesRef.current.filter(
          (msg) =>
            !winIds.includes(msg.id) && msg.id !== winnerMessageRef.current.id,
        );
      }
    }

    if (currentState === RND_CLEAR) {
      setWinIds([]);
      setShowedMessages([]);
      nextMessageIndexRef.current = -1;
      messagesRef.current = [];
      lastMessageIdRef.current = 0;
    }

    prevStateRef.current = currentState;
  }, [currentState]);

  const getBroadcastInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // При запуске следующей трансляции обновление
      if (iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        nextMessageIndexRef.current = -1;
        setShowedMessages([]);
        messagesRef.current = [];
        iactiveIdRef.current = iactiveId;
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)

      // if (
      //   data?.statusList[0]?.state &&
      //   getActiveState(data?.statusList[0]?.state) !== currentState
      // ) {
      //   const curState = getActiveState(data?.statusList[0].state);

      //   let prevState = currentState;

      //   if (prevState === 'S7' && ['S5', 'S6'].includes(curState)) {
      //     setSpeed(speedSlow + 500);
      //     setTimeout(() => {
      //       setShowedMessages(
      //         showedMessages.filter((item) => !winIds.includes(item.id)),
      //       );
      //     }, 100);

      //     setTimeout(() => {
      //       setSpeed(curState === 'S5' ? speedSlow : speedFast);
      //     }, speedSlow + 500);
      //   }
      //   // setCurrentState(curState);

      //   if (curState === 'S5' && speed !== speedSlow) {
      //     setSpeed(speedSlow);
      //   } else if (curState === 'S6' && speed !== speedFast) {
      //     setSpeed(speedFast);
      //   }

      //   if (curState === 'S7') {
      //     if (
      //       winnerMessageRef.current &&
      //       !winIds.includes(winnerMessageRef.current.id)
      //     ) {
      //       setWinIds([...winIds, winnerMessageRef.current.id]);
      //       messagesRef.current = messagesRef.current.filter(
      //         (msg) =>
      //           !winIds.includes(msg.id) &&
      //           msg.id !== winnerMessageRef.current.id,
      //       );
      //     }
      //   }

      //   if (curState === 'S8') {
      //     setWinIds([]);
      //     setShowedMessages([]);
      //     nextMessageIndexRef.current = -1;
      //     messagesRef.current = [];
      //     lastMessageIdRef.current = 0;
      //     return;
      //   }
      // }

      // Удаляем сообщения по команде пользователя
      if (
        showedMessages.some((item) =>
          deletedMessagesIdList.includes(Number(item.id)),
        )
      ) {
        setShowedMessages(
          showedMessages.filter(
            (item) => !deletedMessagesIdList.includes(Number(item.id)),
          ),
        );
      }

      // Удаляем сообщения F2 по команде пользователя
      if (
        showedMessagesF2.some((item) =>
          deletedMessagesIdList.includes(Number(item.id)),
        )
      ) {
        setShowedMessagesF2((prev) =>
          prev.filter(
            (item) => !deletedMessagesIdList.includes(Number(item.id)),
          ),
        );
      }

      // если список сообщений пустой
      if (Array.isArray(messagesList) && messagesList.length === 0) {
        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id ===
                    messagesRef.current[nextMessageIndexRef.current]?.id,
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }
          messagesRef.current = newState;
        }

        // для сообщений F2
        if (
          messagesRefF2.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRefF2.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRefF2.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageF2IndexRef.current &&
                  el.id ===
                    messagesRefF2.current[nextMessageF2IndexRef.current]?.id,
              )
            ) {
              if (
                messagesRefF2.current[nextMessageF2IndexRef.current] ===
                messagesRefF2.current[messagesRefF2.current.length - 1]
              ) {
                nextMessageF2IndexRef.current--;
                if (nextMessageF2IndexRef.current < 0)
                  nextMessageF2IndexRef.current = 0;
              }
            }
            if (
              i < nextMessageF2IndexRef.current &&
              !newState.find((el) => el.id === messagesRefF2.current[i].id)
            ) {
              nextMessageF2IndexRef.current--;
              if (nextMessageF2IndexRef.current < 0)
                nextMessageF2IndexRef.current = 0;
            }
          }
          messagesRefF2.current = newState;
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }

        return;
      }

      // Удаляем сообщения, если они не содержат текста или картинки.
      messagesList = messagesList.filter(
        (el) =>
          !(
            Array.isArray(el.message.attachments) &&
            el.message.attachments.length > 0 &&
            typeof el.message.attachments[0] === 'object' &&
            el.message.attachments[0].type === 'audio_msg' &&
            el.message.content === ''
          ),
      );
      messagesList = messagesList.filter((m) => m.message.content);

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      const messagesListF1 = messagesList.filter((m) => m.titrTag === 'F2');
      const messagesListF2 = messagesList.filter(
        (m) =>
          m.titrTag === 'F1' && m.message?.image !== '1' && m.message?.image,
      );

      const newMsgsF1 = messagesListF1.reverse().slice(-repeatCount);

      // предзагрузка картинок
      loadAvatarAndAttach(messagesListF2);
      loadAvatarAndAttach(newMsgsF1);

      // удаление дубликатов
      let result = [...messagesRef.current, ...newMsgsF1];
      result = deletedDuplicateByAuthor(result, nextMessageIndexRef);

      let resultF2 = [...messagesRefF2.current, ...messagesListF2.reverse()];
      resultF2 = deletedDuplicateByAuthor(resultF2, nextMessageF2IndexRef);

      messagesRef.current = result
        .filter((msg) => !winIds.includes(msg.id))
        .slice(-repeatCount);

      messagesRefF2.current = resultF2;
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);

          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const iterateIndexF2 = (array) => {
    if (!array.length) {
      nextMessageF2IndexRef.current = -1;
      return;
    }
    if (nextMessageF2IndexRef.current < array.length - 1) {
      nextMessageF2IndexRef.current++;
    } else {
      if (messagesRefF2.current.length >= startFrom) {
        messagesRefF2.current = messagesRefF2.current.slice(-repeatCount);
        nextMessageF2IndexRef.current = 0;
      }
    }
  };

  const updateShowedMessages = (newMessages) => {
    if (newMessages && messagesRef.current.length >= startFrom) {
      currentMessageRef.current = newMessages;
      const currentMessageWithUUID = { ...newMessages, UUID: uuidv4() };

      const newMessagesArr = [currentMessageWithUUID, ...showedMessages].slice(
        0,
        6,
      );
      winnerMessageRef.current = newMessagesArr[2];
      setShowedMessages(newMessagesArr);
    }
  };

  const updateShowedMessagesF2 = (newMessages) => {
    if (newMessages && messagesRefF2.current.length >= startFrom) {
      const currentMessageWithUUID = { ...newMessages, UUID: uuidv4() };

      const newMessagesArr = [
        currentMessageWithUUID,
        ...showedMessagesF2,
      ].slice(0, 10);
      setShowedMessagesF2(newMessagesArr);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        // iterateIndexF2(messagesRefF2.current);
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
        // updateShowedMessagesF2(
        //   messagesRefF2.current[nextMessageF2IndexRef.current],
        // );
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);
      if (
        !messagesRef.current[nextMessageIndexRef.current]?.id ||
        (showedMessages.some(
          (el) => el.id === messagesRef.current[nextMessageIndexRef.current].id,
        ) &&
          carousel === '0')
      ) {
        return;
      } else if (carousel === '1' && messagesRef.current.length < startFrom) {
        return;
      } else {
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    },
    currentState === RND_SLOW || currentState === RND_FAST ? speed : null,
  );

  useInterval(
    () => {
      iterateIndexF2(messagesRefF2.current);
      if (messagesRefF2.current.length < startFrom) {
        return;
      } else {
        updateShowedMessagesF2(
          messagesRefF2.current[nextMessageF2IndexRef.current],
        );
      }
    },
    currentState === QUIZ_AVATARS ? 1500 : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 2000);

  return {
    // currentState,
    isVisible,
    showedMessages,
    messagesRef: messagesRef.current,
    winnerMessage: winnerMessageRef.current,
    speed,
    setSpeed,
    showedMessagesF2,
  };
};
